import { ApiResponse } from "@/utils/ApiResponse";
import { CategoriasProductoInterface } from "../../interfaces/categoriaInterfaces/CategoriasProducto.interface";
import { PaginacionFilterParams } from "@/utils/PaginacionFilterParams";
import apiClient from "@/clients/apiClient";

export async function ListCategoriasProductoAction(
  paginacionFilterParams: PaginacionFilterParams
): Promise<ApiResponse<CategoriasProductoInterface>> {
  const { data } = await apiClient.get<CategoriasProductoInterface>(
    "/gpCategoriasProducto",
    {
      params: paginacionFilterParams,
    }
  );
  return {
    status: 200,
    data,
    message: "Categorías de productos obtenidas correctamente",
  };
}
